export const SET_CURRENT_SEARCH = 'set-current-search';
const setCurrentSearch = ({ newSearch, shouldGetQuotes = true }) => ({
  type: SET_CURRENT_SEARCH,
  payload: { newSearch, shouldGetQuotes },
});
export default setCurrentSearch;
